<template>
  <section>
    <v-row v-if="obj">
      <v-col>
        <v-select
          :items="waitMethods"
          label="Wait For"
          v-model="obj.method"
          outlined
          :prepend-icon="selectedIcon"
          hide-details
          dense
          :disabled="deactivated"
        >
          <template v-slot:item="{ item }">
            <v-list-item class="px-1">
              <v-list-item-action class="mx-0">
                <v-icon small> mdi-{{ item.icon }} </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> {{ item.text }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
      </v-col>
      <v-col v-if="obj.method == 'sleep'" class="pa-0 mt-4">
        <v-slider
          v-model="obj.time"
          :label="obj.time + ' Sec'"
          max="60"
          min="1"
          :disabled="deactivated"
        >
        </v-slider>
      </v-col>
      <v-col v-if="obj.method == 'element'">
        <v-text-field
          v-model="obj.selector"
          label="Selector"
          clearable
          dense
          :disabled="deactivated"
          hide-details
          outlined
          @input="changed"
          required
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-0" v-if="obj.method == 'element'">
      <v-col class="mt-2" cols="auto"> TO BE </v-col>
      <v-col class="pa-1">
        <Tooltip
          content="When checked - <strong>Failure</strong> of the WaitFor method will also <strong>fail</strong> the step."
          top
          color="teal"
        >
          <v-select
            v-model="obj.state"
            :items="elementStatus"
            hide-details
            outlined
            @input="changed"
            dense
          />
        </Tooltip>
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col class="mt-2" cols="auto"> Time-Out </v-col>
      <v-col class="pa-1">
        <Tooltip
          content="When checked - <strong>Failure</strong> of the WaitFor method will also <strong>fail</strong> the step."
          top
          color="teal"
        >
          <v-text-field
            v-model="obj.timeout"
            label="Timeout"
            clearable
            type="number"
            :min="0"
            :max="600"
            value="30"
            dense
            :disabled="deactivated"
            hide-details
            outlined
            @input="changed"
            required
          >
          </v-text-field>
        </Tooltip>
      </v-col>
      <v-col cols="auto" class="pa-1">
        <Tooltip
          content="When checked - <strong>Failure</strong> of the WaitFor method will also <strong>fail</strong> the step."
          top
          color="orange"
        >
          <v-checkbox
            v-model="obj.mandatory"
            dense
            label="Waiting is Mandatory"
            :disabled="deactivated"
            @changed="changed"
          ></v-checkbox>
        </Tooltip>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts">
import { WaitFor } from "@/types";
import Vue from "vue";
import VueTypes from "vue-types";
import Tooltip from "./Tooltip.vue";

export default Vue.extend({
  name: "WaitFor",
  data() {
    return {
      waitMethods: [
        { divider: true, header: "Wait For:" },
        { text: "Sleep", value: "sleep", icon: "sleep" },
        { text: "Element Appearance", value: "element", icon: "eye" },
        { text: "Event Triggered", value: "event", icon: "calendar-clock" },
        { text: "Function to execute", value: "function", icon: "function" },
        { divider: true, header: "Load Events:" },
        {
          text: "Document Content",
          value: "content",
          icon: "code-tags",
        },
        { text: "Navigation To End", value: "nav", icon: "cloud-tags" },
        {
          text: "Network To End",
          value: "network",
          icon: "access-point-check",
        },
      ],
      elementStatus: [
        { text: "Visible", value: "visible", icon: "eye" },
        { text: "Hidden", value: "hidden", icon: "eye-off" },
        { text: "Exists", value: "attached", icon: "table" },
        { text: "Not Exists", value: "detached", icon: "table-off" },
      ],
    };
  },
  props: {
    value: VueTypes.any.def({}),
    disabled: VueTypes.bool.def(false),
  },
  methods: {
    changed() {
      this.$emit("input", this.obj);
    },
  },
  computed: {
    obj: {
      get(): WaitFor {
        console.log(this.value);

        return this.value;
      },
      set(val: WaitFor | undefined) {
        this.changed(val);
      },
    },
    deactivated() {
      return this.disabled;
    },
    selectedIcon(): string {
      const val = this.obj.method;
      const method = this.waitMethods.find((m) => m.value == val);
      return `mdi-${method.icon}` || "mdi-sleep";
    },
  },
  updated() {
    this.changed();
  },
  components: { Tooltip },
});
</script>
